import {
  QuestionService,
  CreateQuestionDto,
  UpdateQuestionDto,
} from '@services/api'
import { createAsyncThunk } from '@reduxjs/toolkit'
import { Actions } from '@state/actions'

// const questionsList: QuestionDto[] = [
//   {
//     id: 1,
//     siteId: 2,
//     label: 'Origine',
//     question: 'Suite à quel évenement la douleur est-elle apparue?',
//     questionType: QuestionTypeEnum.open,
//     exams: [],
//   },
//   {
//     id: 2,
//     siteId: 2,
//     label: 'Temps',
//     question: 'Quand la douleur est-elle apparue?',
//     questionType: QuestionTypeEnum.date,
//     exams: [],
//   },
//   {
//     id: 3,
//     siteId: 2,
//     label: 'Allergie?',
//     question: 'Avez-vous des allergies connues?',
//     questionType: QuestionTypeEnum.open,
//     exams: [],
//   },
//   {
//     id: 4,
//     siteId: 2,
//     label: 'Allergie(s)',
//     question: 'Si oui lesquelles:',
//     questionType: QuestionTypeEnum.open,
//     exams: [],
//   },
//   {
//     id: 5,
//     siteId: 2,
//     label: 'Antécédent(s)',
//     question: 'Avez-vous déjà subie un traumatisme?',
//     questionType: QuestionTypeEnum.close,
//     exams: [],
//   },
// ]
export const findAllQuestions = createAsyncThunk(
  Actions.QUESTION_FIND_ALL,
  async (
    query: { examId?: number; includeExams?: boolean; siteId?: number },
    { rejectWithValue },
  ) => {
    try {
      // const questions: any = await QuestionService.findAllQuestions()
      // return questions
      return QuestionService.findAll(query)
    } catch (e: any) {
      if (e.response) {
        return rejectWithValue(e.response.data.message)
      }
      return rejectWithValue(e.response.data.message)
    }
  },
)

export const findSiteQuestions = createAsyncThunk(
  Actions.QUESTION_FIND_BY_SITE,
  async (params: { siteId: number }) => {
    return QuestionService.findAll({ siteId: params.siteId })
  },
)

export const updateQuestion = createAsyncThunk(
  Actions.QUESTION_UPDATE,
  async (
    { id, body }: { id: number; body: UpdateQuestionDto },
    { rejectWithValue },
  ) => {
    try {
      return await QuestionService.update({ id, body })
    } catch (e: any) {
      if (e.response) {
        return rejectWithValue(e.response.data.message)
      }
      return rejectWithValue(e.response.data.message)
    }
  },
)
export const createQuestion = createAsyncThunk(
  Actions.QUESTION_CREATE,
  async (body: CreateQuestionDto, { rejectWithValue }) => {
    try {
      return await QuestionService.create({ body })
    } catch (e: any) {
      if (e.response) {
        return rejectWithValue(e.response.data.message)
      }
      return rejectWithValue(e.response.data.message)
    }
  },
)
export const deleteQuestions = createAsyncThunk(
  Actions.QUESTION_REMOVE,
  async ({ ids }: { ids: number[] }, { rejectWithValue }) => {
    try {
      return await QuestionService.delete({ ids })
    } catch (e: any) {
      if (e.response) {
        return rejectWithValue(e.response.data.message)
      }
      return rejectWithValue(e.response.data.message)
    }
  },
)

export const deleteQuestion = createAsyncThunk(
  Actions.QUESTION_DELETE,
  async (id: number, { rejectWithValue }) => {
    try {
      await QuestionService.deleteById(id)
      return id
    } catch (e: any) {
      return rejectWithValue(
        e.response?.data?.message ?? 'Failed to delete question',
      )
    }
  },
)

export const bulkDeleteQuestions = createAsyncThunk(
  Actions.QUESTION_BULK_DELETE,
  async (ids: number[], { rejectWithValue }) => {
    try {
      await QuestionService.deleteBulk(ids)
      return ids
    } catch (e: any) {
      return rejectWithValue(
        e.response?.data?.message ?? 'Failed to bulk delete questions',
      )
    }
  },
)

export const saveOrderingInfo = createAsyncThunk(
  Actions.QUESTION_SAVE_ORDERING_INFO,
  async (payload: {
    items: {
      examId: number
      questionId: number
      sortIndex: number
      childQuestion: { childQuestionId: number; orderingIndex: number }[]
    }[]
  }) => {
    return QuestionService.saveOrderingInfo(payload)
  },
)

export const bulkUpdateQuestionExams = createAsyncThunk(
  Actions.QUESTION_BULK_UPDATE_EXAMS,
  async (payload: { questionIds: number[]; examId: number }) => {
    return QuestionService.bulkUpdateExams(payload)
  },
)
